import React, { useState, useEffect } from 'react'
import { Table, Button } from 'react-bootstrap'
import { FaSearch, FaPencilAlt, FaTrashAlt, FaPlus } from 'react-icons/fa'
import { connect, useSelector } from 'react-redux'
import Pagination from '../helpers/hoc/paginator/Pagination'
import Loader from '../helpers/hoc/loader/Loader'
import NoRecordFound from '../helpers/hoc/noRecordFound'
import GPDeleteConfirmationModal from './groups/gp-list/gp-delete-confirmation-modal/GPDeleteConfirmationModal'
import OemSubscribedVehicleModal from './OemSubscribedVehicleModal'
import {
  fetchOemSubscribedVehicles,
  addOemSubscribedVehicle,
  updateOemSubscribedVehicle,
  deactivateOemSubscribedVehicle
} from '../../store/actions/fleetDataService'
import { getFormattedDate } from '../../utils/common-methods'
import './OemSubscribedVehicles.css'

const OEM_TABS = [
  { key: 'bajaj', label: 'Bajaj' },
  { key: 'euler', label: 'Euler' },
  { key: 'tata', label: 'Tata' },
  { key: 'eicher', label: 'Eicher' },
  { key: 'nemo', label: 'Mahindra' },
  { key: 'switch', label: 'Switch' }
]

const ITEMS_PER_PAGE = 10

const OemSubscribedVehicles = ({
  oemSubscribedVehicles,
  oemSubscribedVehiclesCount,
  fetchOemSubscribedVehicles
}) => {
  const [selectedOem, setSelectedOem] = useState('bajaj')
  const [searchTerm, setSearchTerm] = useState('')
  const [currentPage, setCurrentPage] = useState(1)
  const [showInactive, setShowInactive] = useState(true)
  const [modalOpen, setModalOpen] = useState(false)
  const [modalMode, setModalMode] = useState('add')
  const [editVehicle, setEditVehicle] = useState(null)
  const [deleteConfirm, setDeleteConfirm] = useState(false)
  const [deleteTarget, setDeleteTarget] = useState(null)
  const isLoading = useSelector((s) => s?.loader?.isLoading)

  const fetchData = () => {
    fetchOemSubscribedVehicles({
      oemKey: selectedOem,
      searchKey: searchTerm,
      page: currentPage,
      pageSize: ITEMS_PER_PAGE,
      showInactive
    })
  }

  useEffect(() => {
    fetchData()
    // eslint-disable-next-line
  }, [selectedOem, currentPage, searchTerm, showInactive])

  const handleOemChange = (key) => {
    setSelectedOem(key)
    setCurrentPage(1)
    setSearchTerm('')
  }

  const handleSearch = (e) => {
    setSearchTerm(e.target.value)
    setCurrentPage(1)
  }

  const handleAddClick = () => {
    setEditVehicle(null)
    setModalMode('add')
    setModalOpen(true)
  }

  const handleEditClick = (vehicle) => {
    setEditVehicle(vehicle)
    setModalMode('edit')
    setModalOpen(true)
  }

  const handleDeleteClick = (vehicle) => {
    setDeleteTarget(vehicle)
    setDeleteConfirm(true)
  }

  const handleModalSubmit = (payload, mode) => {
    setModalOpen(false)
    if (mode === 'edit') {
      updateOemSubscribedVehicle(payload, fetchData)
    } else {
      addOemSubscribedVehicle(payload, fetchData)
    }
  }

  const handleDeleteConfirm = () => {
    setDeleteConfirm(false)
    if (deleteTarget) {
      deactivateOemSubscribedVehicle(
        { oemKey: selectedOem, _id: deleteTarget._id },
        fetchData
      )
      setDeleteTarget(null)
    }
  }

  const startIndex = (currentPage - 1) * ITEMS_PER_PAGE

  return (
    <div className='main-container container-fluid'>
      {isLoading && <Loader isLoading={isLoading} />}

      <h5 className='oem-sub-heading'>OEM Subscribed Vehicles</h5>
      <div className='d-flex flex-row align-item-center justify-content-start'>
        <hr className='hr-line'></hr>
      </div>

      <div className='oem-tab-bar'>
        {OEM_TABS.map(tab => (
          <div
            key={tab.key}
            className={`oem-tab ${selectedOem === tab.key ? 'active' : ''}`}
            onClick={() => handleOemChange(tab.key)}
          >
            {tab.label}
          </div>
        ))}
      </div>

      <div className='oem-sub-toolbar'>
        <div className='oem-sub-search'>
          <div className='search-bar-div search-input fleet-search-bar-div fleetSearchInput'>
            <FaSearch className='vob-search-icon' />
            <input
              type='text'
              value={searchTerm}
              className='vob-search-input search-input'
              onChange={handleSearch}
              placeholder='Search'
            />
          </div>
          <label className='oem-inactive-toggle'>
            <input
              type='checkbox'
              checked={showInactive}
              onChange={() => { setShowInactive(!showInactive); setCurrentPage(1) }}
            />
            Show Inactive
          </label>
        </div>
        <div className='oem-sub-actions'>
          <Button className='oem-add-btn' onClick={handleAddClick}>
            <FaPlus size={12} /> Add Vehicle
          </Button>
        </div>
      </div>

      {oemSubscribedVehicles?.length > 0 ? (
        <div className='bg-white mb-1 position-relative mt-2'>
          <Table responsive borderless className='mb-0'>
            <thead className='nd_table-head'>
              <tr className='table-header'>
                <th><span className='fw500'>S.No.</span></th>
                <th><span className='fw500'>Registration No.</span></th>
                <th><span className='fw500'>Chassis No.</span></th>
                {selectedOem === 'nemo' && <th><span className='fw500'>VIN</span></th>}
                <th><span className='fw500'>Model</span></th>
                <th><span className='fw500'>OEM</span></th>
                <th><span className='fw500'>Source</span></th>
                <th><span className='fw500'>Status</span></th>
                <th><span className='fw500'>Modified By</span></th>
                <th><span className='fw500'>Updated At</span></th>
                <th><span className='fw500'>Note</span></th>
                <th><span className='fw500 action_span'>Action</span></th>
              </tr>
            </thead>
            <tbody className='table-body'>
              {oemSubscribedVehicles.map((v, index) => (
                <tr key={v._id} className={v.isActive === false ? 'oem-inactive-row' : ''}>
                  <td>{startIndex + index + 1}</td>
                  <td>{v.registrationNumber}</td>
                  <td>{v.chassisNumber}</td>
                  {selectedOem === 'nemo' && <td>{v.vin || '-'}</td>}
                  <td>{v.model || '-'}</td>
                  <td>{v.oem || '-'}</td>
                  <td>{v.source || '-'}</td>
                  <td>
                    <span className={`oem-status-badge ${v.isActive !== false ? 'active' : 'inactive'}`}>
                      {v.isActive !== false ? 'Active' : 'Inactive'}
                    </span>
                  </td>
                  <td>{v.modifiedByUserEmail || '-'}</td>
                  <td>{v.updatedAt ? getFormattedDate(v.updatedAt) : '-'}</td>
                  <td>{v.note || '-'}</td>
                  <td>
                    <div style={{ display: 'flex', gap: '6px' }}>
                      <button className='oem-action-btn' onClick={() => handleEditClick(v)} title='Edit'>
                        <FaPencilAlt size={12} />
                      </button>
                      {v.isActive !== false && (
                        <button className='oem-action-btn delete' onClick={() => handleDeleteClick(v)} title='Deactivate'>
                          <FaTrashAlt size={12} />
                        </button>
                      )}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
          <Pagination
            currentPage={currentPage}
            totalPages={Math.ceil((oemSubscribedVehiclesCount || 0) / ITEMS_PER_PAGE)}
            setPage={setCurrentPage}
          />
        </div>
      ) : (
        !isLoading && <NoRecordFound />
      )}

      {modalOpen && (
        <OemSubscribedVehicleModal
          show={modalOpen}
          onClose={() => setModalOpen(false)}
          onSubmit={handleModalSubmit}
          vehicle={editVehicle}
          oemKey={selectedOem}
          mode={modalMode}
        />
      )}

      {deleteConfirm && (
        <GPDeleteConfirmationModal
          handleClose={() => { setDeleteConfirm(false); setDeleteTarget(null) }}
          isOpen={deleteConfirm}
          onDeleteHandler={handleDeleteConfirm}
          message={`Are you sure you want to deactivate vehicle ${deleteTarget?.registrationNumber}?`}
        />
      )}
    </div>
  )
}

const mapStateToProps = (state) => ({
  oemSubscribedVehicles: state.getFleetReducer.oemSubscribedVehicles,
  oemSubscribedVehiclesCount: state.getFleetReducer.oemSubscribedVehiclesCount
})

export default connect(mapStateToProps, {
  fetchOemSubscribedVehicles
})(OemSubscribedVehicles)
